import SearchableSelect from './SearchableSelect';

const ROLE_LABELS = {
  GESTIONNAIRE: 'Gestionnaire',
  AGENT: 'Agent',
};

const MissionFilters = ({ filters, onChange, onReset, statuses, assignees = [], isManager }) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    onChange({ ...filters, [name]: value });
  };

  return (
    <div className="card filters-card">
      <div className="filters-grid">
        <label className="form-field">
          <span>Recherche</span>
          <input
            name="keyword"
            value={filters.keyword || ''}
            onChange={handleChange}
            placeholder="Mot cle (3+ caracteres)"
          />
        </label>
        <label className="form-field">
          <span>Statut</span>
          <select name="statut" value={filters.statut || ''} onChange={handleChange}>
            <option value="">Tous</option>
            {statuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </label>
        <label className="form-field">
          <span>Règlement</span>
          <select name="regle" value={filters.regle || ''} onChange={handleChange}>
            <option value="">Tous les dossiers</option>
            <option value="true">Réglés</option>
            <option value="false">Non réglés</option>
          </select>
        </label>
        {isManager && (
          <SearchableSelect
            label="Responsable"
            name="agentId"
            value={filters.agentId || ''}
            onChange={handleChange}
            placeholder="Tous"
            searchPlaceholder="Rechercher un responsable..."
            options={assignees.map((user) => ({
              value: String(user.id),
              label: `${user.login} (${ROLE_LABELS[user.role] || user.role})`,
            }))}
          />
        )}
        <label className="form-field">
          <span>Du</span>
          <input
            type="date"
            name="fromDate"
            value={filters.fromDate || ''}
            onChange={handleChange}
          />
        </label>
        <label className="form-field">
          <span>Au</span>
          <input
            type="date"
            name="toDate"
            value={filters.toDate || ''}
            onChange={handleChange}
          />
        </label>
      </div>
      <div className="filters-actions">
        <button type="button" className="btn btn-secondary" onClick={onReset}>
          Reinitialiser
        </button>
      </div>
    </div>
  );
};

export default MissionFilters;



